import type { Fallacy } from "./types";
import { createStory } from "./types";

export const misleadingStatistics: Fallacy = {
    id: "misleading-statistics",
    name: "Misleading Statistics",
    emoji: "📈",
    category: "Manipulasi Statistik",
    description: "Menggunakan **grafik atau visualisasi data yang menipu** untuk menciptakan **kesan yang tidak sesuai** kenyataan.",
    tldr: "Grafiknya kelihatan naik drastis, padahal cuma main-main sama sumbu Y.",
    detail: "Misleading Statistics terjadi ketika data disajikan dengan cara yang **secara teknis benar** namun sengaja **menciptakan kesan yang salah**. Teknik ini sangat umum dalam iklan, berita, dan presentasi bisnis.\n\nTrik paling umum adalah memanipulasi sumbu grafik. Dengan memotong sumbu Y agar tidak dimulai dari nol, **perubahan kecil bisa terlihat sangat dramatis**. Kenaikan dari 1.000 ke 1.050 (hanya 5%) bisa terlihat seperti lonjakan besar jika sumbu Y dimulai dari 990.\n\nUntuk melindungi diri, selalu perhatikan: apakah sumbu dimulai dari nol? Apa ukuran sampelnya? Apakah perbandingannya adil? Dan yang terpenting — siapa yang membuat grafik ini dan apa motivasinya?",
    story: createStory("Misleading Statistics", "📈", {
      hook: {
        title: "Lihat grafik melesat tajam?",
        body: "Coba cek sumbu Y-nya. Mulai dari 0 gak? Kalau nggak, kamu lagi ditipu visualisasi.",
      },
      convo: {
        claim: "**Kriminalitas Jakarta melonjak 200%** berdasarkan data 2026 vs 2020! Ibu kota makin gak aman.",
        response: "2020 itu pas PSBB, semua di rumah. **Dibandingin 2019, angkanya justru turun 8%.**",
      },
      reveal: {
        body: "Data yang **secara teknis benar** tapi disajikan dengan cara yang **sengaja bikin kesan salah**. Grafik dipotong, periode dipilih, rata-rata digelembungin.",
      },
      insight: {
        title: "Trik favoritnya?",
        body: "Pilih periode perbandingan yang menguntungkan. Bandingin sama titik terendah biar **keliatan naik drastis** — padahal kalau bandinginnya fair, trennya biasa aja.",
      },
      engagement: {
        title: "Pernah nemu grafik atau data yang \"terlalu bagus\"? 📊",
        body: "Di berita atau presentasi kantor? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["cherry-picking", "simpsons-paradox", "base-rate-fallacy", "sampling-bias"],
  };
